import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface UndervaluedGem {
  id: string;
  rank: number;
  name: string;
  ticker: string;
  current_price_aud: number | null;
  market_cap: number | null;
  ai_score: number | null;
  key_metrics: string | null;
  rationale: string[] | null;
  risk_level: string | null;
  category: string | null;
  swyftx_url: string | null;
  logo_url: string | null;
  price_source: string | null;
  coingecko_id: string | null;
  last_updated: string;
}

export const useUndervaluedGems = (limit = 8) => {
  return useQuery({
    queryKey: ["undervalued-gems", limit],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("undervalued_gems")
        .select("*")
        .order("rank", { ascending: true })
        .limit(limit);
      if (error) throw error;
      return (data || []) as unknown as UndervaluedGem[];
    },
    staleTime: 5 * 60 * 1000,
  });
};
